import { render, staticRenderFns } from "./WorkflowComposite.vue?vue&type=template&id=0a051f48&"
import script from "./WorkflowComposite.vue?vue&type=script&lang=js&"
export * from "./WorkflowComposite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports